import React from "react";

// core components
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Messages from "./Messages.jsx";

const ImportantPage = props => {
  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <Messages />
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default ImportantPage;
